var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 960) scale(1, -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515.303 411.136c-112.214 0-203.479 90.939-203.479 202.752s91.265 202.752 203.479 202.752c112.214 0 203.479-90.939 203.479-202.752s-91.265-202.752-203.479-202.752zM515.303 779.776c-91.797 0-166.483-74.419-166.483-165.888s74.686-165.888 166.483-165.888c91.797 0 166.483 74.419 166.483 165.888s-74.686 165.888-166.483 165.888zM811.272 79.36h-591.938c-30.591 0-55.494 24.814-55.494 55.296 0 2.511 0.509 62.116 45.32 121.651 26.082 34.652 61.784 62.185 106.133 81.792 54.153 24.008 121.463 36.173 200.010 36.173s145.834-12.165 200.010-36.173c44.349-19.653 80.050-47.14 106.133-81.792 44.812-59.535 45.32-119.14 45.32-121.651 0-30.482-24.903-55.296-55.494-55.296zM515.303 337.408c-129.001 0-224.197-35.136-275.297-101.606-38.291-49.812-39.147-100.708-39.17-101.238 0-10.092 8.278-18.363 18.498-18.363h591.938c10.22 0 18.498 8.248 18.498 18.432 0 0.438-0.856 51.356-39.17 101.146-51.124 66.47-146.32 101.606-275.297 101.606v0.023z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/clients.249195ba306871e7fa52d5dda4e5da5a.svg";
export { ForwardRef as ReactComponent };